<template>
    <div class="uk-margin-top">
        <slot class="uk-text-left"></slot>
        <!-- <p>{{index}}</p> -->
        <div class="uk-margin-top">
            <div class="uk-column-1-2 uk-margin-top">
                <div class="uk-border-rounded border uk-padding uk-text-center" :class="{selected:selected_el === 'A'}" @click="updateAnswer('A')">
                    {{ answers.a }}
                </div>
                <div class="uk-border-rounded border uk-padding uk-text-center" :class="{selected:selected_el === 'B'}" @click="updateAnswer('B')">
                    {{ answers.b }}
                </div>
            </div>
            <div class="uk-column-1-2 uk-margin-top">
                <div class="uk-border-rounded border uk-padding uk-text-center" :class="{selected:selected_el === 'C'}" @click="updateAnswer('C')">
                    {{ answers.c }}
                </div>
                <div class="uk-border-rounded border uk-padding uk-text-center" :class="{selected:selected_el === 'D'}" @click="updateAnswer('D')">
                    {{ answers.d }}
                </div>
            </div>
        </div>
        <hr>
    </div>
</template>

<script>
export default {
    name: "multiple-choice-question",
    props: ["answers", "index"],
    data () {
        return {
            answer: "none",
            selected_el: ""
        }
    },
    methods: {
        updateAnswer(newanswer){
            this.selected_el = newanswer
            this.$emit('updateAnswer', {index:this.index, answer:newanswer})
        }
    }
}
</script>

<style lang="less" scoped>
    .border {
        border: 1px solid #1e87f0;
        cursor: pointer;
    }
    .border:hover {
        color: #ffffff;
        background-color: #2ea1ff;
    }

    .selected {
        color: #ffffff;
        background-color: #1e87f0;
    }
</style>
